import React, { useCallback, useEffect, useState, useRef } from 'react'
import '../styles/watchBody.css'
import WatchItem from './watchItem'
import WatchComments from './watchComments'
import { EmptyMassage, FeedLoadBar } from './comps'
import { useSelector } from 'react-redux'
import { watchClipPath } from '../utils/mediaRoute'

const LINE_KEY = 'pinweelo-watch-line'

const WatchBody = props => {
  const translations = useSelector(state => state.lang_reduse.lang)
  const ref = useRef(null)
  const jumpedFor = useRef(null)
  const allowSave = useRef(false)
  const [isFetching, setIsFetching] = useState(false)
  const [activeIndex, setActiveIndex] = useState(0)
  const [commentPostId, setCommentPostId] = useState(null)
  const [hidden, setHidden] = useState([])
  const list = (Array.isArray(props.list) ? props.list : []).filter(item => !hidden.includes(String(item.id)))

  const jumpTo = (index) => {
    const node = ref.current
    if (!node) return
    const height = Math.max(node.clientHeight, 1)
    const next = Math.max(0, index)
    allowSave.current = false
    node.scrollTop = next * height
    setActiveIndex(next)
    const item = list[next]
    if (props.rememberLine && item && item.id) sessionStorage.setItem(LINE_KEY, String(item.id))
    window.setTimeout(() => { allowSave.current = true }, 0)
  }

  const onScroll = () => {
    const node = ref.current
    if (!node) return
    const height = Math.max(node.clientHeight, 1)
    const nextIndex = Math.round(node.scrollTop / height)
    setActiveIndex(prev => (prev === nextIndex ? prev : nextIndex))
    if (!isFetching && node.scrollTop + node.clientHeight + 30 >= node.scrollHeight) {
      setIsFetching(true)
    }
    props.storyChrome?.current?.onScroll(node)
  }

  useEffect(() => {
    if (!isFetching) return
    Promise.resolve(props.fetchData()).finally(() => setIsFetching(false))
  }, [isFetching])

  useEffect(() => {
    if (!list.length) return undefined
    const wanted = String(props.startId || '') || (props.rememberLine ? String(sessionStorage.getItem(LINE_KEY) || '') : '')
    const idx = wanted ? list.findIndex(post => String(post.id) === wanted) : 0
    const next = idx < 0 ? 0 : idx
    const key = `${wanted}:${next}`
    if (jumpedFor.current === key) return undefined
    jumpedFor.current = key
    const apply = () => jumpTo(next)
    apply()
    const frame = window.requestAnimationFrame(apply)
    return () => window.cancelAnimationFrame(frame)
  }, [props.startId, list, props.rememberLine])

  useEffect(() => {
    const item = list[activeIndex]
    if (!item || !item.id) return
    if (allowSave.current && props.rememberLine) sessionStorage.setItem(LINE_KEY, String(item.id))
    if (!props.rememberLine) return
    if (!jumpedFor.current) return
    const path = watchClipPath(item.id)
    const page = window.location.pathname
    if (page !== '/watch' && page !== '/watch/') return
    const here = `${page}${window.location.search || ''}`
    if (here === path) return
    try {
      window.history.replaceState(window.history.state, '', path)
    } catch (_) {}
  }, [activeIndex, list, props.rememberLine])

  const openComments = useCallback(postId => setCommentPostId(postId), [])

  useEffect(() => {
    if (!props.startComment || !props.startId) return
    setCommentPostId(props.startId)
  }, [props.startComment, props.startId])

  return (
    <div className="WatchBody" ref={ref} onScroll={onScroll}>
      {props.error && <EmptyMassage list={list} title={props.error} color="#fff" />}
      <EmptyMassage loading={!!props.isload && list.length === 0} list={list} title={translations.thereisnovideos} color="#fff" />

      {list.map((item, index) => (
        <WatchItem
          key={item.id || item.title}
          item={item}
          active={index === activeIndex}
          nearby={Math.abs(index - activeIndex) <= 1}
          onOpenComments={openComments}
          onImmersive={props.onImmersive}
          onHide={id => setHidden(ids => [...ids, String(id)])}
        />
      ))}

      {isFetching && <FeedLoadBar />}
      {commentPostId && (
        <WatchComments postId={commentPostId} highlightId={props.startComment} onClose={() => setCommentPostId(null)} />
      )}
    </div>
  )
}

export default WatchBody
